import React from "react";
import { Avatar } from "@stardust-ui/react";
import { toStringMessageDate } from "../vendor/DateUtil";

export const StartMedia = () => {
  const date = new Date();
  toStringMessageDate(date);
  return <Avatar />;
};
